const API_URL = process.env.REACT_APP_API_URL;

// Helper function to get auth token (add this at the top)
const getAuthToken = () => {
  return localStorage.getItem('authToken') || '';
};

export const postPreLbaData = {
  // Fetch all documents for a specific case


  async getPostPreLbaData(userId) {
    try {
      const response = await fetch(`${API_URL}/api/postprelba/data/${userId}`, {
        headers: {
          "Authorization": `Bearer ${getAuthToken()}`
        }
      });
      const data = await response.json();

      return data;
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  


};